

export default {
    title: 'BIT NETWORK',
    home: {
        theme: 'Blockchain infrastructure specifically designed for RDA tokenization.',
        advantage: [
            'Delivering efficient, secure, and compliant solutions ',
            'to empower the digital transformation of the real economy.',
        ],
        core: {
            title: 'Three Core Initiatives of BIT',
            open: {
                title: 'Open Source',
                content: 'Fostering an open-source community to spur the development of a robust network of financial products and services to help people access and use the BIT network.',
            },
            decent: {
                title: 'Decentralization',
                content: 'Growing the network by adding more validator nodes and increasing the superminority through delegations.',
            },
            pledge: {
                title: 'Staking',
                content: 'Facilitate staking by providing grants, open source reference implementations, and community support.',
            },
        },
        market: {
            title: 'Cryptocurrency Market',
        },
        globalpoint: {
            title: 'Global Nodes',
            title2: 'Global Node List',
            search_title: 'Default sorting by BIT nodes in descending ',
            search_icon: 'Search by node ',
            item1: 'Rank',
            item2: 'Account',
            item3: 'Amount',
            item4: 'Height',
            global_title: ' Anytime, Anywhere',
            download: 'Scan to Download',
            rule: 'Node Mining Output Rules',
        },
        statistic: {
            title: 'BIT public chain data',
            accountCount: 'Total Accounts',
            transactionCount: 'Total Transactions',
            voteCount: 'Voting Power',
            tokenCount: 'Total Value',
            accountCount2: 'Total BIT Issuance',
            liutong: 'Total BIT Circulating Supply',
            transactionCount2: 'Total BIT Nodes',
            voteCount2: 'Total BIT Staked',
            tokenCount2: 'Total BIT Block Rewards',  
            stakeCount: 'Total BIT Staking Rewards',
        },
        statisticCount: {
            node: 'Node',
            contract: 'Contract',
            token: 'Token',
        },
     
        member: {
            title: 'BIT Foundation Main Members',
            annie: {
                name: 'Annie',
                position: 'Director of the Singapore BIT Foundation',
                describe: 'Responsible for the executive affairs of the foundation and the management of BIT tokens',
            },
            lin: {
                name: 'Lin',
                position: 'Vice Director of Singapore BIT Foundation',
                describe: 'Responsible for assisting the daily work of the board of directors',
            },
            tommy: {
                name: 'Tommy',
                position: 'Council Member of Hong Kong Blockchain Technology Application Association',
                describe: 'CEO of Hong Kong Qianyuan Bite Investment and Financing Management Co., Ltd.',
                describe1: 'Over 10 years of industry experience.',
            },
            lucius: {
                name: 'Lucius',
                position: 'Financial Architect and Data Analyst',
                describe: 'With over 10 years of experience in the financial and blockchain industries, having operated and served multiple blockchain projects, including 2 public chain projects.',
            },
            mark: {
                name: 'Mark',
                position: '• National Senior Software Engineer and System Architect',
                describe: '• Has led multiple large-scale software projects and blockchain solutions',
            },
            oxf: {
                name: '0xF',
                position: 'Business Incubator (BIT) Network CTO',
                describe: 'Member of Singapore BIT Foundation',
            },
            oxhi: {
                name: '0xHi',
                position: 'Business Incubator (BIT) Network Laboratory',
                describe: 'Member of Singapore BIT Foundation',
            },
        },
        future: {
            title: 'BIT Future Planning Roadmap',
            time:['2022.05','2023.08', '2024.10','2024.11', '2024.12', '2025.05','2025.08','2025.10','2025.11','2026.03','2026.10','2027.05','2028.03','2029.10'],
            content1: 'The BIT Network project has been officially launched, with the core development team fully assembled. We have completed the selection of underlying technologies and architectural design, and started writing core protocol code, laying a solid theoretical and technical foundation for the upcoming intelligent network era.',
            content2:'BIT Network has taken a crucial step by launching the construction of its native community. We are attracting early-stage developers and blockchain enthusiasts through multiple channels to jointly discuss the future of the ecosystem, build community consensus, and inject vitality into the long-term development of the project.',
            content3:'The mainnet of BIT Network has been officially launched, marking the full arrival of the BIT intelligent network era. The mainnet launch signifies that we now possess an independent, secure, and efficient blockchain network, providing core support for all subsequent ecological applications.',
            content4:'One month after the mainnet launch, in November 2024, the BIT token was officially listed on exchanges for trading. This initiative provides initial liquidity, enabling a broader market to participate in and evaluate the value of the BIT network.',
            content5:'The BIT cross-chain bridge service has been launched on schedule. It has successfully established an asset circulation channel between the BIT network and other mainstream public chains such as BNB Chain, achieving multi-chain interconnection and greatly expanding the ecological boundaries.',
            content6:'The construction of BITSwap, the core decentralized exchange of the ecosystem, has been launched. It will provide convenient exchange and liquidity mining services for native assets within the network, and become the traffic and value exchange hub of the BIT DeFi ecosystem.',
            content7: 'BIT Network reached a major milestone by successfully onboarding the first batch of RDA (Real-World Data Asset) enterprises on-chain. This brings traditional financial assets onto the blockchain, opening a new chapter of asset digitization and demonstrating its practical value.',
            content8: 'BIT Network fully embraces open source, releasing its core code to developers worldwide. Meanwhile, network nodes officially launched and began producing incentives, marking a new stage of decentralized governance and community co-governance.',
            content9: 'BIT Network will host its first global online launch event to showcase project achievements, technical strengths, and future vision. This aims to expand global influence and attract more partners and users.',
            content10: 'BIT Network will launch its first global hackathon. We will offer generous prizes to encourage outstanding developers worldwide to build innovative applications on our public chain, grow the ecosystem, and discover the next generation of killer DApps.',
            content11: 'Ecosystem applications will continue to advance, with an on-chain marketplace and integrated social tools going live. They blend blockchain technology with everyday scenarios, offering a new Web3 experience and enriching user lifestyles.',
            content12: 'BIT Network aims to achieve the ambitious goal of onboarding a hundred enterprises on-chain. Numerous companies will deploy various business applications on our network, demonstrating BIT Network’s technical maturity and commercial appeal.',
            content13: 'The team will embark on a global roadshow across major fintech hubs worldwide. In parallel, the BIT token plans to list on top global cryptocurrency exchanges, gaining unprecedented liquidity and market recognition.',
            content14: 'In October 2029, BIT Network’s initial node reward cycle concludes successfully. We plan to launch a more ambitious second phase and draft the next seven-year roadmap, moving toward a fully mature and autonomous ecosystem.',
            
        },
    BITdonate: {
        title: 'BIT Donation Plan',
        title2: 'Support BIT Network',
         content4: 'BIT Foundation, Supporting Children with Disabilities',
    },
     RWAcooperate: {
        title: 'RDA Enterprise Partners',
    },
    },
    point: {
        
        title: 'Decentralized Power',
        title2: 'Start with a node, join the network',
        describe: 'From passive users to active contributors & shapers – BIT Network empowers you to shape the digital future.',
        describe2: 'Earn rewards, vote, and truly own your digital future.',
        
    },
       tablehaead: {
            item1: 'Token',
            item2: 'Price',
            item3: 'Circulation',
            item4: 'Total Circulation',
            item5: 'Market Cap (Circulation)',
            item6: 'Total Market Cap',
            item7: '24H Trading Volume',
            item8: 'Change %',
        },
     
   
    ecology: {
        title: 'Six Major Ecosystems',
        theme: [
            'Multidimensional Integration, ',
            'Reshape RDA Ecosystem Value Network',
        ],
        advantage: [
            'Built on BIT EVM',
            'Drive Global RDA Value Cooperation’s New Era',
        ],
        pledge: {
            name: 'Staking',
            title: 'BIT Staking',
            describe: 'Open, transparent, all on-chain',
            ex: [
                {
                    title: 'Participate in the election voting',
                    describe: ["Holders of BIT, the native token of BIT Network, can stake it to earn BIT Power for on-chain voting. The 19 candidates with the most votes will serve as BIT Network’s validators, responsible for block production and transaction packaging."]
                },
                {
                    title: 'Protect the network',
                    describe: ['BIT Network is a DPoS network where Super Representatives (SRs) record and validate transactions. If an SR is inefficient or unavailable, voters can transfer their votes to better nodes to secure the network.']
                },
                {
                    title: 'Share block rewards',
                    describe: ['BIT Network’s Incentive Model: Block-Producing Witnesses Earn BIT Rewards for Voters .']
                },
            ],
            quantityReward: {
                title: 'Calculate your staking rewards',
                pledge: 'I want to staking',
                reward: 'Eastern Time, Reward',
                tips: '* The estimated BIT rewards here are calculated based on the selected staking duration and the input amount of BIT. Actual APY and BIT rewards may vary.',
                btn: 'STAKING →',
            },
        },
        wallet: {
            name: 'Wallet',
            title: 'BIT Wallet',
            describe: 'Specifically designed to provide storage and various ecological links for all "tokens" on the BIT Network.',
            ex: [
                {
                    title: 'Manage BIT digital assets',
                    describe: ["Digital asset management is the most fundamental and core function of the BIT wallet. Compared to digital assets being scattered across various decentralized platforms, the BIT wallet can aggregate users' digital assets for unified management. Of course, the most important aspect is that it enhances the security of digital assets."]
                },
                {
                    title: 'Log in to decentralized applications (DApps)',
                    describe: ["Allows users to interact with decentralized applications. These applications are typically built on blockchain technology and feature decentralization, transparency, and immutability. Users can log in using wallets and utilize DApps, significantly enhancing the user experience and efficiency. At the same time, the BIT wallet serves as a bridge for the circulation of digital assets."]
                },
                {
                    title: 'Authentication',
                    describe: ["The BIT wallet can also be used to manage users' identity information. Users can use the wallet for identity verification and share their identity information when needed. This can be used for various purposes, such as online voting, digital identification, KYC (Know Your Customer), and more."]
                },
            ],
        },
        scan: {
            name: 'Block Explorer',
            title: 'BIT Block Explorer',
            describe: 'The BIT block explorer is designed to be transparent, and all information can be verified.',
            ex: [
                {
                    title: 'Execution Data',
                    describe: ['The executed data refers to transactions that have been executed within a specific block. A new block is added to the BIT block explorer every 3 seconds (unless the block proposer misses the proposal opportunity), resulting in a nearly stable flow of data being added to the block explorer.']
                },
                {
                    title: 'Consensus Layer Data Network',
                    describe: [
                        'The highest level data of the consensus layer includes the following content:',
                        '· Current period',
                        '· Current slot',
                        '· Active validators - Number of active validators',
                        '· Pending validators - Number of validators waiting for activation',
                        '· Staked BIT - Amount of BIT staked in the network',
                    ]
                },
            ],
        },
        swap: {
            name: 'Decentralized Exchange',
            title: 'BIT Decentralized Exchange',
            describe: 'BIT decentralized exchange (dapp) is built on a decentralized network, integrating smart contracts and various front-end interfaces of its ecosystem.',
            ex: [
                {
                    title: 'Decentralization',
                    describe: ['Run on BIT Network, which is an open public decentralized platform that no individual or group can control.']
                },
                {
                    title: 'Trustless computation / verifiable behavior',
                    describe: ['BIT smart contracts can analyze and ensure execution in a predictable manner, while decentralizing trust from organizations.']
                },
                {
                    title: 'Data Integrity',
                    describe: ['Due to the use of cryptographic primitives, the data stored on the blockchain is immutable and indisputable. Malicious actors cannot forge publicly available transactions or other data.']
                },
                {
                    title: 'Resist Censorship',
                    describe: ['No entity on the internet can prevent users from submitting transactions, deploying dapps, or reading data on the blockchain.']
                },
                {
                    title: 'Privacy',
                    describe: ['Customers do not need to provide real-world identity to deploy or interact with dapps.']
                },
                {
                    title: 'Zero Downtime',
                    describe: ['Smart contracts deployed on the BIT Network allow the entire network to provide services to customers wishing to interact with the contracts. Therefore, malicious actors cannot launch DoS attacks against a single dapp.']
                },
            ],
        },
        nft: {
            name: 'NFT',
            title: 'BIT Non-Fungible Token (NFT)',
            describe: 'BIT non-fungible tokens (NFTs) are empowering content creators like never before.',
            ex: [
                {
                    title: 'BIT Non-Fungible Token (NFT) Uses:',
                    describe: [
                        '· The BIT non-fungible tokens have various uses, including:',
                        '· Proof of attendance at an event  ',
                        '· Proof of completion of a course ',
                        '· In-game items owned  ',
                        '· Digital art  ',
                        '· Tokenization of physical assets  ',
                        '· Proof of online identity ',
                        '· Restriction of content access ',
                        '· Issuance of credentials  ',
                        '· Distributed internet domain names',
                        '· Collateral in decentralized finance ',
                    ]
                },
            ],
            detailDescribe: 'Assuming you are an artist who wants to share your works using NFT while retaining control over your creations and avoiding intermediary profit cuts. You can create a new contract that specifies the number of NFT, their attributes, and the link to the specific artwork. As the artist, you can set up royalties in the smart contract (for example, transferring 5% of the sale price to the contract owner each time the NFT is transferred). Since you own the wallet that deployed the contract, you can always prove that you are the creator of the NFT. Your buyers can also easily prove that they own the genuine NFT representing your series of artworks, as their wallet address is associated with a token in your smart contract. They can use the NFT throughout the BIT ecosystem, as its authenticity is guaranteed.'
        },
        community: {
            name: 'Community',
            title: 'BIT Community Super Representative',
            describe: 'On the BIT network, all BIT holders can apply to become SR candidates and have the opportunity to become an SR or SR partner.',
            ex: [
                {
                    title: '',
                    describe: [
                        'Any BIT holder can vote for SR candidates, with the top 19 candidates receiving the most votes becoming SRs, while candidates ranked 20th to 199th will become SR partners.',
                        'SRs are responsible for producing blocks and packaging transactions, receiving voting rewards and block rewards; SR partners only receive voting rewards and do not undertake the aforementioned two tasks.',
                        'All SR candidates, SR partners, and SRs have the right to propose changes to the BIT network parameters.',
                    ]
                },
            ],
        },
    },
    contribute: {
        theme1: 'Real-World Assets New Cornerstone ',
        theme2: ' on Chain',
        advantage: 'Goodbye volatility, hello steady returns from physical assets.',
        advantage2: 'Lead the next digital revolution at BIT.',
        module1: {
            title: 'BIT Ecosystem',
            describe: 'The teams within the BIT Network ecosystem operate many funding programs. Typically, these programs focus on specific verticals or specialties to meet the needs of particular applicants. The following ecosystem teams manage their own funding programs.',
            product: [
                {
                    title: 'MAX',
                    describe: 'MAX (Unlimited) is a digital product initiated by the Singapore Sequoia Foundation, which integrates crowdfunding, competition, and collateralized lending protocols, using blockchain hash values as the basis for judgment.',
                },
                {
                    title: 'TC',
                    describe: 'The decentralized exchange "Tianchi", jointly created by the Singapore Sequoia Foundation and the BIT Network, serves as a trading venue specifically designed for all ecological tokens on the BIT Network within the BIT Network ecological cluster. Other on-chain tokens can also be traded here.',
                },
                {
                    title: 'PROJECT A',
                    describe: 'Jointly developed by the 5A Foundation and the BIT Network, users can earn daily released TVL returns by investing in BIT tokens and USDT. Users can also obtain high returns through targeted referrals and community development.',
                },
                {
                    title: 'MOBIUS BAND',
                    describe: 'MOBIUS BAND is a blockchain game under the BIT Network ecosystem that allows players to earn rewards through blind box extraction. It aims to support BIT DAO builders in innovating in areas such as governance tools, security, and tokenization.',
                },
                {
                    title: 'BUARES',
                    describe: 'A completely decentralized on-chain wealth creation program created by the BIT Network ecosystem in collaboration with the TON Foundation aims to promote a hundredfold appreciation of USDT, with the goal of maximizing the extractable value (MEV) of USDT.',
                },
                {
                    title: 'PHOENIX',
                    describe: "Phoenix is BIT's first attempt at the Chinese blockchain market, aimed at supporting BIT Network projects targeted at everyday users, providing funding and marketing support, and increasing awareness within the BIT Network ecosystem.",
                },
                {
                    title: 'Chain DuoDuo',
                    describe: "Heavenly stems and earthly branches come together, a chain of stars brings many blessings. This is a public platform provided by the BIT public network for enterprises, which can be used to promote product sales. Users can also obtain products through this method while enjoying corresponding benefits.",
                },
                {
                    title: 'The Blockchain of XiYou',
                    describe: 'This is a blockchain game application themed around "XiYou" launched by the BIT public network. Users can obtain complete NFTs while enjoying corresponding rights and benefits. It also aims to entertain and educate more people about the culture of "Journey to the West," spreading it into the WEB 3.0 industry and around the world.',
                },
                {
                    title: 'QueQiao',
                    describe: 'QueQiao Cross - Chain Bridge, with zero - knowledge proof technology at its core, realizes the fast interconnection of multi - chain assets and data. It is safe and efficient, adapts to scenarios such as DeFi and NFT, and creates a smooth cross - chain experience for users.',
                },
                {
                    title: 'Web 3.0 Mobile Phone',
                    describe: 'Integrating a decentralized wallet and DApp ecosystem, supporting multi - chain interaction, and equipped with a hardware encryption chip to ensure asset security, the Web 3.0 mobile phone helps users enjoy on - chain social networking and DeFi, opening up a convenient web3.0 life.',
                },
                {
                    title: 'BIT deepseek',
                    describe: 'BIT deepseek, based on advanced large model technology, possesses efficient reasoning and learning capabilities, supports multimodal interaction, is widely applied in scenarios such as intelligent office and content creation, and provides users with intelligent and efficient solutions.',
                },
                {
                    title: 'BIT kimi',
                    describe: 'BIT Kimi, relying on self-developed large models, supports ultra-long contexts of 2 million words, excels in multi-format file processing and programming assistance, covers scenarios such as academia and creation, and provides intelligent and efficient AI solutions.',
                },
            ]
        },
        module2: {
            title: 'Community Public Product Funding',
            describe: 'The BIT Network ecosystem is a vibrant and ever-evolving community, with numerous community initiatives also funding public goods within the BIT Network ecosystem. Examples include:',
            product: [
                {
                    title: 'SENTINEL',
                    describe: 'The sentinel program funds influential public goods through representatives elected by the community, who vote on the impact of the projects and allocate funds accordingly from the matching pool.',
                },
            ]
        }
    },
    server: {
        theme: 'Server Hosting',
        advantage: 'Access servers for validators through monthly contracts with world-class data center providers. This optional program enables decentralized system operators to utilize hardware typically reserved for large organizations.',
        plan: {
            title: 'About this plan',
            content: [
                'High-quality servers are a key component of network operations. However, individuals sometimes find it difficult to acquire new servers. Therefore, the BIT Network Foundation collaborates with multiple data center providers worldwide to offer server leasing services to the BIT Network ecosystem through flexible monthly contracts on behalf of the BIT Network validator community.',
                'This optional program aims to promote the sustainable development of validators and the BIT Network community, further decentralizing the BIT network.',
            ]
        },
        run: {
            title: 'How does the entire process work?',
            content: [
                'Use the "Register Here" button above to sign up for the program. At this point, individuals will be prompted to complete the KYC ("Know Your Customer") process. The KYC process is a necessary requirement for participating in the program.',
                'Eligible individuals will receive a welcome email and a Server Plan Agreement (SPA), which will be sent to the provided email address.',
            ]
        },
        problem: {
            title: 'Frequently Asked Questions',
            content: [
                {
                    question: 'What is the price of the server?',
                    answer: 'After registering for the program, you can obtain accurate server prices directly from the applicable data center providers.',
                },
                {
                    question: 'What are the server specifications?',
                    answer: 'All servers have been standardized to meet the long-term needs of the network.',
                },
                {
                    question: 'How long does it take to register and gain access?',
                    answer: 'The entire process should only take a few days from start to finish, but at the fastest, it will take just one day. The foundation aims to make the entire process as simple as possible to help individuals obtain infrastructure in a timely manner.',
                },
                {
                    question: 'How is billing calculated?',
                    answer: 'When you register to participate in the data center, you will enter your credit card information, and the server provider will bill you monthly.',
                },
                {
                    question: 'Is the BIT Foundation profiting from hardware sales through this program?',
                    answer: 'No',
                },
            ]
        },
    },
    develop: {
        theme: 'BIT Development Guide',
        title: 'Power Your Tech Journey',
        advantage: 'Backed by precise positioning, strong team strength, first-mover advantage',
        advantage2: 'and global potential, BIT Network leads the RDA track.',
        github: {
            title: 'Software Project Hosting Platform - Github',
            describe: 'BIT Network is deeply integrated with GitHub to create a seamless Web3 building experience for developers.',
            describe2: 'BIT Network leads RDA with precise positioning, strong team, first-mover edge & global potential.',
            describe3: 'BIT Network extends GitHub’s open-source vitality via smart contracts & token economics into a sustainable incentive ecosystem, empowering every developer’s creation.',
            describe4: 'Core Advantages:',
            btn: 'Learn More',
            advantage: 'Developer-Friendly: Low Learning Curve',
            advantage2: 'Secure & Transparent: Code Verifiable',
            advantage3: 'Ecosystem Incentive: Empowering Open Source Contributions',
        },
        redbook: {
            title: 'BITNetwork - Red Book',
            describe: 'BIT Network is a blockchain infrastructure focused on the tokenization of real-world data assets (RDA), dedicated to mapping traditional world assets to the chain in the form of securitization and providing efficient financial application scenarios for them.',
            describe2: 'BIT Network connects TradFi & DeFi, supports high-throughput dApps via modular chains (Optimistic/ZKRollup), boosts asset liquidity/tradability/interoperability, and integrates smart contracts to embed RDA into lending/staking/derivatives – unlocking real yields and on-chain business models.',
            describe3: 'By empowering institutions and ecological partners, BIT Network endeavors to build a next-generation financial network that combines compliance, scalability, and real commercial application value.',
            btn: 'Learn More',
        },
        sdk: {
            title: 'BIT SDK - Technical White Paper',
            describe: 'BIT SDK is a comprehensive, powerful developer toolset supporting BIT ecosystem native apps & meta-services. It integrates rich blockchain capabilities (ecological frameworks, app services) covering account management, chain interaction & smart contracts.',
            describe2: 'BIT SDK offers efficient, secure, user-friendly dev components to lower technical barriers – letting developers focus on innovation and quickly build/deploy high-performance DeFi/RDA dApps across scenarios. It’s the key technical cornerstone empowering developers and boosting BIT ecosystem prosperity & mass adoption.',
            btn: 'Learn More',
        },
    },

    past: {
        title: 'Previous RDA Summit Highlights',
        content: 'BIT Network held its first RDA Summit on December 15-16, 2023, in Shanghai, showcasing BIT Networks innovation and practice in the RDA field.'
    },
    introduce: {
        title: 'RDA Enterprise Introduction',
        title1: 'Hengxiang Technology KW Smart Chain',
        content1: 'As a leading enterprise in intelligent and safe electricity consumption in China, Hengxiang Technology, together with Bit Network and RDA Accelerator, has launched a tokenization strategy based on real-world Date assets (RDA). Relying on 200,000 AloT devices online, hundreds of intellectual property rights, and high-quality electrical data, the company transforms physical assets into KW tokens, a digital token that can circulate globally, building a new ecosystem of "asset operation + financial services". This initiative aims to activate hundreds of billions of dormant assets, open up low-cost global financing channels, and create a new benchmark for digital finance in the field of electrical safety.',
        title2: 'Art Chain Global ACG Smart Chain',
        content2: 'Art Chain Global is the worlds first RDA platform focusing on the digitalization of Chinese art and cultural assets. Relying on Bit Networks high-performance public chain and RDA Accelerators compliant channels, it collaborates with the "Belt and Road Wang Suoping International Art Center" to transform top artworks into tradable and divisible digital assets. The platform aims to solve the liquidity dilemma of art assets, establish global pricing power for Chinese culture, and through the native token ACG, build a new paradigm of digital finance for "cultural export", practice the strategy of cultural power, and open a new era of global Chinese art value.'
    },
    Configuration: {
        detail: ['Learn About Us', 'Download App'],
        pages: ['Previous Page', 'Next Page']
    },
    node: {
       
        content: 'node',
        content2: 'country / region',
    },
    nav: {
        menu: ['HOME', 'EXPLORER', 'STAKING', 'NODES', 'RDA', 'DEVELOPER', 'NEWS/NOTICE'],
        bottom: ['BIT Red Book', 'Technical Document', 'Open Source', 'Audit'],
    },
    footer: {
        content: ['About Us', 'Privacy Policy', 'Terms of Service', 'Services ', 'API', 'Contact Us', 'Resources', 'BIT Architecture', 'BIT Red Paper V2.0', 'Technical White Paper V3.1.6'],
         right:'BIT Blockchain Explorer',
        download:'Download BIT wallet',
        c: 'Copyright© 2025-2028 All rights reserved.',
    },
    word: {
        title: 'Hong Kong International Investment Association',
        content: 'Established in 2015, Hong Kong International Investment Association (legally registered in HK SAR) is co-initiated by China International Chamber of Commerce’s Investment and Financing Committee and Tomorrow Better Foundation, with financial leaders from Hong Kong and the mainland. Honorary Patrons: then HK SAR CE Leung Chun-ying, Liaison Office Director Zhang Xiaoming. It drives cross-border capital-industrial integration, serves fintech/green energy/digital infrastructure projects, and collaborates with HK SFC/HKMA/Treasury Bureau.',
    },
    word2: {
        title: 'Hong Kong Blockchain Technology Application Association',
        content: 'Founded in 2020 and recognized by the HKSAR Government, the Association connects blockchain technology and ecosystem resources across Hong Kong, Mainland China, Southeast Asia, the Middle East, and North America. It focuses on integrating blockchain with real-economy scenarios and, together with Coinstreet and other top institutions, provides one-stop digital transformation services, cross-border financing, and digital asset distribution, seamlessly accessing emerging markets.',
    },
    word3: {
        title: 'Shenzhen Information Service Industry Blockchain Association',
        content: 'Established in December 2019 in Qianhai, Shenzhen. It is Shenzhen’s earliest and largest municipal blockchain industry association. The inauguration involved senior national and municipal leaders and authorities, marking a significant milestone for the city’s blockchain development.',
    },
    word4: {
        title: 'Hong Kong Qianyuan Bit Investment & Financing Co., Ltd.',
        content: 'Headquartered in Hong Kong, an international financial center, the company focuses on the integration of blockchain technology with Real-World Date Assets (RDA). With deep insights into digital assets, it provides capital empowerment, global resource integration, and compliant frameworks for high-quality innovation projects worldwide—building a bridge between traditional finance and the digital future, and driving the growth and application of the RDA ecosystem.',
    },
    News: {
        title: 'BIT News Flash',
        title2: 'Perceive Ecosystem Pulse',
        content: 'Deeply focus on the pulse of BIT ecosystem, and gain insight into the rapidly changing industry.',
        content2: 'Our news flash, your weather vane.'
    },
    accelerate: {
        title: 'RDA Accelerator',
        content: 'Hong Kong RDA Accelerator is a strategic project jointly initiated by Hong Kong Blockchain Technology Application Association and Hong Kong International Investment Association. Through the innovative model of "data cross-border + asset on-chain", it builds a full-chain closed-loop from domestic asset digitalization, cross-border data circulation, to international market trading, aiming to build an efficient and compliant bridge for mainland physical assets and global capital markets.',
        title2: 'Four Major RDA Accelerator Endorsements'
    },
     NODE:{
        title:'NUMBER',
        title2:'DISTRIBUTION',
        title3:'RANKING (BY COUNTRY AND REGION)',
       
    },
    Detail:{ 
        back:'Back to List',
        previous:'Previous Article',
        next:'Next Article',
        date:'Publication Date',
        user:'Article Author'

    },
}